import { listingArticlesBlogMock, rubriquesBlogMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [listingArticlesBlogMock('b2c'), rubriquesBlogMock];

export const blogB2cMock: SlugPage = {
  ...pageBase({
    title: 'Blog B2c',
    type: 'undefined',
    language: 'fr-FR',
    headerId: 'header-b2b-fr',
    headerSubMenuId: 'menu-blog-b2c',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
